import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Avatar from "@mui/material/Avatar";
import { ThemeContext } from "context/ThemeContext";
import { AuthContext } from "context/Authentication";
import commonStyles from "templates/default/assets/styles/commonstyles/commonStyles";

export default function Branding() {
  const themeMode = useContext(ThemeContext);
  const darkMode = themeMode.state.darkMode;
  const context = useContext(AuthContext);

  return (
    <Box
      sx={{
        mr: 2,
        padding: "10px",
        display: { xs: "none", md: "flex" },
      }}
    >
      <Link to="/">
        {context.state.companyInfo &&
        Object.entries(context.state.companyInfo).length > 0 ? (
          <img
            alt={context.state.companyInfo.Company_Name}
            src={
              darkMode
                ? process.env.BASEURL +
                  context.state.companyInfo.Company_Logo_Light
                : process.env.BASEURL +
                  context.state.companyInfo.Company_Logo_Dark
            }
            style={{
              height: "60px",
              objectFit: "contain",
            }}
          />
        ) : (
          <Skeleton variant="circular">
            <Avatar
              sx={{
                width: 65,
                height: 65,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
          </Skeleton>
        )}
      </Link>
    </Box>
  );
}
